import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import GuidesPage from "@/pages/guides/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/cssbuy-spreadsheet-complete-guide",
    element: <ArticlePage />,
  },
  {
    path: "/guides",
    element: <GuidesPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;